/* @flow */
import { UPDATE_CACHED_DISCOUNTS, UPDATE_CACHED_COUPONS } from '../../configs/constants'
import InitialState from './initialState'

const initialState = new InitialState()

export default function discountReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return initialState.merge(state)

  switch (action.type) {
    case UPDATE_CACHED_DISCOUNTS:
      return state.set('all', action.payload)
    case UPDATE_CACHED_COUPONS:
      return state.set('coupons', action.coupons)
    default:
      return state
  }

}


// WEBPACK FOOTER //
// ./src/reducers/discount/index.js